import React, { useCallback, useEffect, useState } from "react";

import { getTrackingEvent, postEmail } from "../services/offers/offers.service";
import {
  CampaignType,
  ContactDetails,
  LayoutClass,
  LayoutDeviceSettings,
  Offer,
  PlacementStage,
  QueryParams,
  QueryPostEmail,
} from "../types/global.types";
import PreviewEmbeddedDME6 from "../components/templates/templateDME6/PreviewEmbeddedDME6.component";
import PreviewPopupSuper from "../components/templates/templateSuper/PreviewPopupSuper.component";
import PreviewPopupCompact from "../components/templates/templateCompactV2/PreviewPopupCompactV2.component";
import PreviewEmbeddedSuper from "../components/templates/templateEmbeddedSuper/PreviewEmbeddedSuper.component";
import PreviewDynamic from "../components/templates/templateDynamic/PreviewDynamic.component";
import PreviewCategory from "../components/templates/templateCategory/PreviewCategory.component";
import PreviewCompactCheckboxWowcher from "../components/templates/templateCompactCheckboxWowcher/PreviewCompactCheckboxWowcher.component";
import PreviewEmbeddedCompactV2 from "../components/templates/templateEmbeddedCompactV2/PreviewEmbeddedCompactV2.component";
import PreviewEmbeddedHorizontalV2 from "../components/templates/templateEmbeddedHorizontalV2/PreviewEmbeddedHorizontalV2.component";
import PreviewEmbeddedSWowcher from "../components/templates/templateEsWowcher/PreviewEmbeddedSWowcher.component";
import { loadCSSFromUrl, removeCSSFromHead } from "../utility/cssLoader";
import LayoutError from "../components/layout/error";
import { setStorageItem } from "../utility/storage";
import { TEMPLATE_CATEGORY, TEMPLATE_DYNAMIC } from "../utility/template";

function TemplatePage() {
  const [hasAttemptedLoad, setHasAttemptedLoad] = useState(false);

  const [params, setParams] = useState<QueryParams>();
  const [settings, setSettings] = useState<LayoutDeviceSettings>();
  const [isOpen, setOpen] = useState<boolean>(false);
  const [campaign, setCampaign] = useState<CampaignType>();
  const [placementId, setPlacementId] = useState<string>();
  const [layoutId, setLayoutId] = useState<string>();
  const [placementName, setPlacementName] = useState<string>("");
  const [first, setFirst] = useState<boolean>(true);

  const [selectedOffers, setSelectedOffers] = useState<string[]>([]);
  const [offerSlot, setOfferSlot] = useState<number>(0);
  const [singleOffer, setSingleOffer] = useState<Offer | undefined>();
  const [preEmail, setPreEmail] = useState<string>();
  const [isEmail, setIsEmail] = useState<boolean>(false);
  const [emailPostParams, setEmailPostParams] = useState<QueryPostEmail>();
  const [sessionId, setSessionId] = useState<string>("");
  const [isSave, setSave] = useState<boolean>();
  const [isShare, setShare] = useState<boolean>(false);
  const [isSeen, setSeen] = useState<boolean>(false);
  const [isExit, setIsExit] = useState<boolean>(false);

  useEffect(() => {
    if (
      settings !== undefined &&
      placementId !== undefined &&
      params !== undefined &&
      campaign !== undefined
      // ... all variables attempted to load at least once
    ) {
      setHasAttemptedLoad(true);
    }
  }, [settings, placementId, params, campaign]);

  useEffect(() => {
    window.addEventListener("message", function (event) {
      if (Object.keys(event.data).includes("options")) {
        setSettings(event.data?.options);
      }
      if (Object.keys(event.data).includes("isExit")) {
        setIsExit(event.data?.isExit);
      }
      if (Object.keys(event.data).includes("seen")) {
        setSeen(event.data?.seen);
      }
      if (Object.keys(event.data).includes("isSave")) {
        setSave(event.data?.isSave);
      }
      if (Object.keys(event.data).includes("isShare")) {
        setShare(event.data?.isShare);
      }
      if (Object.keys(event.data).includes("open")) {
        setOpen(event.data?.open);
      }
      if (Object.keys(event.data).includes("campaign")) {
        setCampaign(event.data?.campaign);
        if (event.data?.campaign?.placementSettings[0]?.layoutId) {
          setLayoutId(event.data.campaign.placementSettings[0].layoutId);
        }
      }
      if (Object.keys(event.data).includes("queryParams")) {
        setParams(event?.data.queryParams);
      }
      if (Object.keys(event.data).includes("first")) {
        setFirst(event?.data.first);
      }
      if (Object.keys(event.data).includes("selectedOffers")) {
        setSelectedOffers(event?.data.selectedOffers);
      }
      if (Object.keys(event.data).includes("sessionId")) {
        setSessionId(event?.data.sessionId);
      }
      if (Object.keys(event.data).includes("placementId")) {
        setPlacementId(event?.data.placementId);
      }
      if (Object.keys(event.data).includes("placementName")) {
        setPlacementName(event?.data.placementName);
      }

      if (Object.keys(event.data).includes("placementName")) {
        setPlacementName(event?.data.placementName);
      }

      if (Object.keys(event.data).includes("postEmail")) {
        setEmailPostParams(event?.data.postEmail);
      }

      if (Object.keys(event.data).includes("slot")) {
        setOfferSlot(event?.data.slot);
      }

      if (Object.keys(event.data).includes("offer")) {
        setSingleOffer(event?.data.offer);
      }
      if (Object.keys(event.data).includes("isEmail")) {
        setIsEmail(event?.data.isEmail);
      }

      if (Object.keys(event.data).includes("preEmail")) {
        setPreEmail(event?.data.preEmail);
      }

      if (Object.keys(event.data).includes("exit")) {
        setParams(event?.data.exit.queryParams);
        setPlacementName(event?.data.exit.placementName);
        setPlacementId(event?.data.exit.placementId);
        setSettings(event?.data.exit.settings);
        setOpen(true);
      }

      if (Object.keys(event.data).includes("extra")) {
        setSettings(event?.data.extra.settings);
        setParams(event?.data.extra.queryParams);
        setPlacementName(event?.data.extra.placementName);
        setPlacementId(event?.data.extra.placementId);
        setSingleOffer(event?.data.extra.offer);
        setOpen(event.data?.extra.open);
        setCampaign(event.data.extra?.campaign);
        setOfferSlot(event.data?.extra.slot);
      }
    });
  }, []);

  useEffect(() => {
    const isVisible = campaign?.placementSettings[0]?.isVisible;
    if (isSeen && isOpen) {
      if (isVisible) {
        getTrackingEvent({
          event: "ontemplateseen",
          retailerId: campaign?.company_Id,
          campaignId: campaign?.id,
          placementId,
          placementName,
          tid: settings?.template.identifier,
          pltype: campaign?.placementSettings[0]?.displayOnly
            ? PlacementStage.pre
            : PlacementStage.post,
          pltid: layoutId || "",
        });
      }
    }
    // eslint-disable-next-line
  }, [isSeen, isOpen]);

  useEffect(() => {
    return () => window.removeEventListener("message", () => { });
  }, []);

  const handleAutoHeightOnIframe = async () => {
    const ro = new ResizeObserver((entries) => {
      for (let entry of entries) {
        window.parent.postMessage(
          { event: "autoHeightOnIframe", height: entry.contentRect.height },
          "*"
        );

      }
    });
    ro.observe(document.body);


    window.top?.postMessage(
      { event: "autoHeightOnIframe", height: document.body.offsetHeight },
      "*"
    );
  };

  useEffect(() => {
    if (
      (TEMPLATE_CATEGORY.includes(settings?.template.identifier || "") ||
        TEMPLATE_DYNAMIC.includes(settings?.template.identifier || "")) || (
        settings?.settings?.mainLayout?.offersNumber === "auto" &&
        settings?.type === LayoutClass.inline)
    ) {
      document.body.classList.add("tmp-scroll");
      handleAutoHeightOnIframe();
    }
  }, [settings]);

  const handleContactDetailsValidation = (
    post: QueryPostEmail
  ): QueryPostEmail => {
    const contactDetails: ContactDetails[] = post.contactDetails.filter(
      (details: ContactDetails) => details.offerId !== undefined
    );

    const validatedPost = {
      ...post,
      contactDetails,
    };

    return validatedPost;
  };

  const postEmailMethod = async (post: QueryPostEmail) => {
    if (post.contactDetails.length > 0) {
      const response = await postEmail(post);
      if (response?.data?.status) {
        window.top?.postMessage(
          { event: "clearPostEmailStorage", load: "" },
          "*"
        );
      }
    }
  };

  useEffect(() => {
    if (emailPostParams?.companyId && settings?.template && campaign?.campaignGeneralOptions?.saveOfferOptions?.allowEmail) {
      emailPostParams.contactDetails.length > 0 &&
        setPreEmail(emailPostParams.contactDetails[0].email);
      postEmailMethod({
        ...handleContactDetailsValidation(emailPostParams),
        templateId: settings?.template.identifier,
        pltype: PlacementStage.pre,
        layoutId: layoutId || "",
      });
    }
    // eslint-disable-next-line
  }, [emailPostParams]);

  useEffect(() => {
    removeCSSFromHead("font-css");
    if (
      settings?.template.identifier &&
      settings.settings?.mainLayout?.fontFamilyCss
    ) {
      loadCSSFromUrl(settings.settings.mainLayout.fontFamilyCss);
    }
  }, [settings]);

  const getTemplateComponent = useCallback(() => {
    let elm: React.JSX.Element = <></>;
    if (
      settings &&
      placementId &&
      params &&
      campaign?.id &&
      settings.settings &&
      campaign
    ) {
      const isVisible = campaign.placementSettings[0].isVisible;

      if (!isVisible) {
        window.top?.postMessage({ event: "closeMainIframe", load: "" }, "*");
        return <></>;
      }

      switch (settings?.template.identifier) {
        case "template-super-pre":
        case "template-super-post":
          elm = (
            <PreviewPopupSuper
              slot={offerSlot}
              params={params}
              type={settings?.type || LayoutClass.action}
              settings={settings.settings}
              settingsTemplate={settings.template}
              placementId={placementId}
              placementName={placementName}
              buttonShape={settings.button.shape}
              campaignId={campaign.id}
              sessionId={sessionId}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              email={preEmail}
              first={first}
              defaultOpen={isOpen}
              setOpen={setOpen}
              defaultSix={true}
              layoutId={layoutId || ""}
              isExit={isExit}
              device={settings?.template.deviceType}
              isSeen={isSeen}
            />
          );
          break;
        case "template-esuper-pre":
        case "template-esuper-post":
          elm = (
            <PreviewEmbeddedSuper
              sessionId={sessionId}
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              campaignId={campaign.id}
              layoutSettings={settings}
              placementId={placementId}
              placementName={placementName}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              singleOffer={singleOffer}
              isSave={isSave}
              isShare={isShare}
              isEmail={isEmail}
              email={preEmail}
              setIsEmail={setIsEmail}
              setSingle={setSingleOffer}
              layoutId={layoutId || ""}
              device={settings?.template.deviceType}
            />
          );
          break;
        case "template-dynamic-pre":
        case "template-dynamic-post":
          elm = (
            <PreviewDynamic
              sessionId={sessionId}
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              campaignId={campaign.id}
              layoutSettings={settings}
              placementId={placementId}
              placementName={placementName}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              singleOffer={singleOffer}
              isSave={isSave}
              isShare={isShare}
              isEmail={isEmail}
              email={preEmail}
              setIsEmail={setIsEmail}
              setSingle={setSingleOffer}
              layoutId={layoutId || ""}
              device={settings?.template.deviceType}
            />
          );
          break;
        case "template-category-pre":
        case "template-category-post":
          elm = (
            <PreviewCategory
              sessionId={sessionId}
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              campaignId={campaign.id}
              layoutSettings={settings}
              placementId={placementId}
              placementName={placementName}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              singleOffer={singleOffer}
              isSave={isSave}
              isShare={isShare}
              isEmail={isEmail}
              email={preEmail}
              setIsEmail={setIsEmail}
              setSingle={setSingleOffer}
              layoutId={layoutId || ""}
              device={settings?.template.deviceType}
            />
          );
          break;

        case "template-compact-v2-pre":
        case "template-compact-v2-post":
          elm = (
            <PreviewPopupCompact
              sessionId={sessionId}
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              type={settings?.type || LayoutClass.action}
              settings={settings.settings}
              settingsTemplate={settings.template}
              placementId={placementId}
              placementName={placementName}
              buttonShape={settings.button.shape}
              campaignId={campaign.id}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              email={preEmail}
              first={first}
              defaultOpen={isOpen}
              setOpen={setOpen}
              layoutId={layoutId || ""}
              isExit={isExit}
              device={settings?.template.deviceType}
            />
          );
          break;

        case "template-DME6":
          elm = (
            <PreviewEmbeddedDME6
              sessionId={sessionId}
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              layoutSettings={settings}
              placementId={placementId}
              placementName={placementName}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              singleOffer={singleOffer}
              isSave={isSave}
              isShare={isShare}
              isEmail={isEmail}
              email={preEmail}
              setIsEmail={setIsEmail}
              setSingle={setSingleOffer}
              layoutId={layoutId || ""}
              device={settings?.template.deviceType}
            />
          );
          break;
        case "template-Es-wowcher":
          elm = (
            <PreviewEmbeddedSWowcher
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              layoutSettings={settings}
              placementId={placementId}
              placementName={placementName}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              singleOffer={singleOffer}
              isSave={isSave}
              isShare={isShare}
              isEmail={isEmail}
              email={preEmail}
              setIsEmail={setIsEmail}
              setSingle={setSingleOffer}
              layoutId={layoutId || ""}
              device={settings?.template.deviceType}
            />
          );
          break;
        case "template-compact-checkbox-wowcher":
          elm = (
            <PreviewCompactCheckboxWowcher
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              layoutSettings={settings}
              placementId={placementId}
              placementName={placementName}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              singleOffer={singleOffer}
              isSave={isSave}
              isShare={isShare}
              isEmail={isEmail}
              email={preEmail}
              setIsEmail={setIsEmail}
              setSingle={setSingleOffer}
              layoutId={layoutId || ""}
              device={settings?.template.deviceType}
            />
          );
          break;

        case "template-embedded-compact-v2":
          elm = (
            <PreviewEmbeddedCompactV2
              sessionId={sessionId}
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              layoutSettings={settings}
              placementId={placementId}
              placementName={placementName}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              singleOffer={singleOffer}
              isSave={isSave}
              isShare={isShare}
              isEmail={isEmail}
              email={preEmail}
              setIsEmail={setIsEmail}
              setSingle={setSingleOffer}
              layoutId={layoutId || ""}
              device={settings?.template.deviceType}
            />
          );
          break;

        case "template-embedded-horizontal-v2":
          elm = (
            <PreviewEmbeddedHorizontalV2
              sessionId={sessionId}
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              layoutSettings={settings}
              placementId={placementId}
              placementName={placementName}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              singleOffer={singleOffer}
              isSave={isSave}
              isShare={isShare}
              isEmail={isEmail}
              email={preEmail}
              setIsEmail={setIsEmail}
              setSingle={setSingleOffer}
              layoutId={layoutId || ""}
              device={settings?.template.deviceType}
            />
          );
          break;

        default:
          elm = (
            <PreviewPopupSuper
              slot={offerSlot}
              params={params}
              isSeen={isSeen}
              type={settings?.type || LayoutClass.action}
              settings={settings.settings}
              settingsTemplate={settings.template}
              placementId={placementId}
              placementName={placementName}
              buttonShape={settings.button.shape}
              campaignId={campaign.id}
              sessionId={sessionId}
              campaignRes={campaign}
              selectedOffers={selectedOffers}
              email={preEmail}
              first={first}
              defaultOpen={isOpen}
              setOpen={setOpen}
              defaultSix={true}
              layoutId={layoutId || ""}
              isExit={isExit}
              device={settings?.template.deviceType}
            />
          );
          break;
      }
    } else if (hasAttemptedLoad) {
      elm = (
        <LayoutError
          message="Failed to send data from script to iframe"
          companyId={campaign?.company_Id || ""}
          placementId={placementId || ""}
          campaignId={campaign?.id || ""}
          templateId={settings?.template.identifier || ""}
          layoutId={layoutId || ""}
          page={params?.pageParams?.page || ""}
        />
      );
    }

    return elm;
  }, [
    isOpen,
    campaign,
    placementId,
    first,
    settings,
    params,
    selectedOffers,
    placementName,
    singleOffer,
    offerSlot,
    isEmail,
    preEmail,
    isSave,
    isShare,
    isSeen,
    sessionId,
    layoutId,
    isExit,
    hasAttemptedLoad,
  ]);

  useEffect(() => {
    if (sessionId) {
      setStorageItem("brswUserSessionId", sessionId, campaign?.cookieOptions);
    }
    // eslint-disable-next-line
  }, [sessionId]);

  return getTemplateComponent();
}

export default TemplatePage;
